// Signup page
import React, { Component, Fragment } from 'react';
import queryString from 'query-string';
import { toast } from 'react-toastify';
import { Spinner } from 'reactstrap';
import SocialButton from '../../Components/SocialButton';
import * as SignupService from '../../Services/SignupService';
import strings from "../../strings/en";
import { Button, Form, FormGroup, Label, Input, Col, CustomInput} from 'reactstrap';
import PreviewSlider from '../../Components/PreviewSlider';

class Signup extends Component {

   // facebookAppId = '834781667004529'; // Dev facebook key
   // facebookAppId = '679943619011315';  // Dev facebook key
   facebookAppId = '351328215521843';   // Live facebook key

   // Dev google key
   // googleClientId = '47239637118-gssjqi1qmqhjs1ih1kgbmul0lqbh8m2a.apps.googleusercontent.com'
   // googleClientId = '231688632496-ggu8ob36vrtkonmf27ulens1cmu26bpf.apps.googleusercontent.com';

   //Live google key
   googleClientId = '380766611471-ffqetkribho0ep6hj9demf6gi9c5o5it.apps.googleusercontent.com';

   queryParams = null;
   months = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
   years = [];

   constructor(props) {
      super(props);
      this.queryParams = queryString.parse(window.location.search)
      this.state = {
         loading: false,
         first_name: '',
         last_name: '',
         email: this.queryParams['email'] ? this.queryParams['email'] : '',
         plan: this.queryParams['plan'] ? this.queryParams['plan'] : 'Growth-Yearly',
         password: '',
         ip: '',
         registered_with: '',
         formErrors: {
            blankEmail: false,
            validEmail: false,
            blankPassword: false,
            validPassword: false,
            validCardNumber: false,
            validCardCVV:false,
            validCardExpMonth:false,
            validCardExpYear: false,
         },
         renderSocialBtn: false,
         shDesignation: '',
         newCreditCardDetail:{
            card_number:'',
            card_cvv:'',
            card_exp_month:'',
            card_exp_year:'',
         },
         isSocialSignup:false,
      }
      this.years = this.getUpcomingYears();
   }

   getUpcomingYears() {
      let years = [];
      let current_year = new Date().getFullYear();
      for (let i = current_year; i < (current_year + 20); i++) {
         (years).push(i);
      }
      return years;
   }

   componentDidMount() {
      this.setState({ loading: true })
      SignupService.getIpAddress().then(response => {
         this.setState({ loading: false })
         let ip = response.data.ip;
         this.setState({ ip: ip });
      })
   }

   /**
    * Function is use for set the email input field.
    */
   handleEmailChange = (event) => {
      let fieldValidationErrors = this.state.formErrors;
      fieldValidationErrors.blankEmail = false;
      fieldValidationErrors.validEmail = false;
      this.setState({ email: event.target.value, formErrors: fieldValidationErrors });
   }

   /**
    * Function is use for set the password input field.
    */
   handlePasswordChange = (event) => {
      let fieldValidationErrors = this.state.formErrors;
      fieldValidationErrors.blankPassword = false;
      fieldValidationErrors.validPassword = false;
      this.setState({ password: event.target.value, formErrors: fieldValidationErrors });
   }

   /**
    * Function is use for set the ShDesignation input field.
    */
   handleShDesignationChange = (event) => {
      this.setState({ shDesignation: event.target.value });
   }

   /**
    * Function is use for check the email validation.
    */
   validateEmail(email) {
      let emailValid = email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
      return emailValid;
   }

   /**
    * Function is use for validate the pattern.
    */
   handleNumberPattern = (number, type) => {
      let fieldValidationErrors = this.state.formErrors;
      if (number){
         if (type === 'cardNumber') {
            let cardNumberPatternValid = number.match(/^[0-9a-zA-Z]*$/);
            if (!cardNumberPatternValid) {
               fieldValidationErrors.validCardNumber = true;
            }
         } else {
            let cardCvvPatternValid = number.match(/^[0-9]{3,4}$/);
            if (!cardCvvPatternValid) {
               fieldValidationErrors.validCardCVV = true;
            }
         }
      }
      this.setState({
         formErrors: fieldValidationErrors
      })
   }

   /**Function to validate card */
   validateCreditCard(){
      let cardDetail = this.state.newCreditCardDetail;
      let fieldValidationErrors = this.state.formErrors;
      let valid = true;
      if ((cardDetail.card_number === '') || (fieldValidationErrors.validCardNumber)) {
         valid = false;
      }
      if ((cardDetail.card_cvv === '') || (fieldValidationErrors.validCardCVV)) {
         valid = false;
      }
      if (cardDetail.card_exp_month === '') {
         valid = false;
      }
      if (cardDetail.card_exp_year === '') {
         valid = false;
      }
      return valid;
   }

   /**
    * Function is use for submit the form values.
    */
   handleSubmit = (event) => {
      event.preventDefault();
      const { newCreditCardDetail ,first_name, last_name, email, plan, registered_with, password, ip, shDesignation} = this.state;
      if (this.validateCreditCard() && email !== '' && this.validateEmail(email) && (registered_with !== '' || (password !== '' && password.length > 5))) {
         this.setState({ loading: true });
         let userData = {
            first_name: first_name,
            last_name: last_name,
            email: email.toLowerCase(),
            registered_with: registered_with,
            password: password,
            profile_pic: '',
            package: plan,
            ip: ip,
            sh_designation: shDesignation,
            cc_token: '',
         }
         // live stripe key
         window.Stripe.setPublishableKey('pk_live_yYiGoHEd5PX653JPKD2nWDVz00s2ZuVmHl');
         // dev stripe key
         // window.Stripe.setPublishableKey('pk_test_rvWDLYCAQuLJhB9cvoDYwKMC00TLiYzidp');
         window.Stripe.card.createToken({
            number: newCreditCardDetail['card_number'],
            exp_month: newCreditCardDetail['card_exp_month'],
            exp_year: newCreditCardDetail['card_exp_year'],
            cvc: newCreditCardDetail['card_cvv']
         }, (status, response) => {
            if (status === 200) {
               let stripeToken = response.id;
               userData.cc_token = stripeToken.toString();
               this.submitForm(userData);
            } else {
               this.setState({ loading: false })
               toast.error(response.error.message);
            }
         });
      } else {
         this.validateField('validate_card');
      }
   }

   /**
    * Function is use for call the signUp function.
    */
   submitForm = (data) => {
      let userData = data;
      // Signup with Tapfiliate
      // if (this.queryParams['ref']) {
      //    console.log(this.queryParams)
      //    userData.is_affiliate = true;
      //    userData.affiliate_ref_code = this.queryParams['ref']
      // }
      SignupService.signUpWithCard(userData).then(response => {
         this.setState({ loading: false});
         if (response.api_status === 1) {
            window.fbq('track', 'CompleteRegistration');
            toast.success("Successfully signed up.");
            let data = response.data;
            localStorage.setItem('isUserLoggedIn', true);
            localStorage.setItem('currentUser', JSON.stringify(data));
            let path = '/admin';
            let domain = window.location.hostname;
            setTimeout(() => {
               window.location.href = window.location.protocol + "//" + domain + path;
            }, 1500)
         } else {
            toast.error(response.message);
         }
      })
      .catch(error =>{
         this.setState({ loading: false});
      })
   }

   /**
    * Function is use for set the social user details.
    */
   handleSocialLogin = (user) => {
      this.setState({
         password:'',
         registered_with: user._provider,
         first_name: user._profile.firstName,
         last_name: user._profile.lastName ? user._profile.lastName : '',
         email: user._profile.email
      },()=>{
         SignupService.checkEmailExist(user._profile.email)
            .then(response => {
               if (response.api_status === 1) {
                  this.setState({isSocialSignup:true});
               } else {
                  this.setState({loading:true});
                  let data = {
                     first_name: this.state.first_name,
                     last_name: this.state.last_name,
                     email: this.state.email.toLowerCase(),
                     registered_with: this.state.registered_with,
                     password: '',
                     profile_pic: '',
                     package: this.state.plan,
                     ip: this.state.ip,
                     sh_designation: this.state.shDesignation,
                  }
                  this.submitForm(data);
               }
            })
      });
   }

   /**
    * Function is use for validate the fields.
    */
   async validateField(key) {
      const { email, password, newCreditCardDetail } = this.state;
      let fieldValidationErrors = this.state.formErrors;
      if (email === '') { fieldValidationErrors.blankEmail = true; }
      if (email !== '' && this.validateEmail(email) === null) {
         fieldValidationErrors.validEmail = true;
      }
      if (password === '') { fieldValidationErrors.blankPassword = true; }
      if (password !== '' && password.length < 6) {
         fieldValidationErrors.validPassword = true;
      }
      if (key === 'validate_card'){
         if (newCreditCardDetail['card_number'] === '') {
            fieldValidationErrors.validCardNumber = true
         }
         if (newCreditCardDetail['card_cvv'] === '') {
            fieldValidationErrors.validCardCVV = true
         }
         if (newCreditCardDetail['card_exp_month'] === '') {
            fieldValidationErrors.validCardExpMonth = true
         }
         if (newCreditCardDetail['card_exp_year'] === '') {
            fieldValidationErrors.validCardExpYear = true
         }
      }
      await this.setState({
         formErrors: fieldValidationErrors
      });
   }

   /**
    * Function is use for show the specific error.
    */
   emptyField(type = '') {
      switch (type) {
         case 'email':
            return (
               <span className="error">{strings.emailValidationText}</span>
            )
         case 'password':
            return (
               <span className="error">{strings.passwordValidationText}</span>
            )
         default:
            return (
               <span className="error">{strings.emptyField}</span>
            )
      }
   }

   /**
    * Function is use for handle the social login error case.
    */
   get socialLoginProps() {
      return {
         onLoginFailure: this.socialLoginErrorCallback
      }
   }

   /**
    * Function is use for if get social login any error, re-render the render.
    */
   socialLoginErrorCallback = (err) => {
      this.setState({ 
         renderSocialBtn: true,
         isSocialSignup: false,
      }, () => { this.setState({ renderSocialBtn: false }) })
   }

   handleChange(key,e,validationKey){
      let newCreditCardDetail = this.state.newCreditCardDetail;
      let formErrors = this.state.formErrors;
      if (formErrors[validationKey]){
         formErrors[validationKey] = false;
      }
      newCreditCardDetail[key] = e.target.value;
      this.setState({ newCreditCardDetail, formErrors});
   }

   render() {
      const { email, password, formErrors, renderSocialBtn, loading, shDesignation, newCreditCardDetail,isSocialSignup } = this.state;
      return (
         <>
            {
               loading ?
                  <div className="rct-loader-wrap d-flex justify-content-center align-items-center">
                     <Spinner className="rct-loader" color="primary" />
                  </div>
                  :
                  <div className="rct-signup-wrap">
                     <div className="logo-wrap">
                        <a href="/" className="d-inline-block">
                           <img alt="logo" className="logo" src={process.env.PUBLIC_URL + "/images/saleshangry-logo.png"} height="60" />
                        </a>
                     </div>
                     <PreviewSlider />
                     <div className="rct-main-panel">
                        <div className="rct-panel-table">
                           <div className="rct-panel-table-cell">
                              <div className="d-flex align-items-center switch-wrap">
                                 <div className="res-logo">
                                    <a href="/" className="d-inline-block">
                                       <img alt="logo" src={process.env.PUBLIC_URL + "/images/saleshangry-logo.png"} height="50" />
                                    </a>
                                 </div>
                                 <div>
                                    <span className="fs-14 pr-3">Already have an account ? </span>
                                    <a href="/login">
                                       <Button className="btn primary-bdr-btn rounded-btn fs-14 text-space">login</Button>
                                    </a>
                                 </div>
                              </div>
                              <div className="mx-auto content-wrap">
                                 <div>
                                    <h4 className="font-normal">Let's Boost Your Business.</h4>
                                    <p className="mb-5">Enter your details to access your fully-loaded 4 day free trial.</p>
                                 </div>
                                 <Form>
                                    {!isSocialSignup &&
                                       <Fragment>
                                          <FormGroup className="input-group-lg">
                                             <Label for="emailId" className="text-uppercase">email address</Label>
                                             <Input type="email" autoComplete="off" value={email} onChange={this.handleEmailChange} placeholder="Email" id="emailId" />
                                             {formErrors.blankEmail && this.emptyField()}
                                             {formErrors.validEmail && this.emptyField('email')}
                                          </FormGroup>
                                          <FormGroup className="input-group-lg">
                                             <Label for="passwordId" className="text-uppercase">password</Label>
                                             <Input type="password" autoComplete="off" value={password} onChange={this.handlePasswordChange} placeholder="Password" id="passwordId" />
                                             {formErrors.blankPassword && this.emptyField()}
                                             {formErrors.validPassword && this.emptyField('password')}
                                          </FormGroup>
                                       </Fragment>
                                    }
                                    <div className="billing-info-wrap">
                                       <span className="sec-title text-uppercase">Add Card</span>
                                       <FormGroup row>
                                          <Col sm={8} lg={8}>
                                             <Input
                                                type="text"
                                                autoComplete="off"
                                                value={newCreditCardDetail['card_number']}
                                                onChange={(e) => this.handleChange('card_number', e, 'validCardNumber')}
                                                placeholder="Card Number"
                                                id="cardNumber"
                                                onBlur = {
                                                   () => this.handleNumberPattern(newCreditCardDetail['card_number'], 'cardNumber')
                                                }
                                             />
                                             {formErrors.validCardNumber ? <span className="error">Please enter a valid card number.</span> : null}
                                          </Col>
                                          <Col sm={4} lg={4}>
                                             <Input
                                                type="text"
                                                autoComplete="off"
                                                value={newCreditCardDetail['card_cvv']}
                                                onChange={(e) => this.handleChange('card_cvv', e,'validCardCVV')}
                                                placeholder="CVV" id="cvv"
                                                onBlur = {
                                                   () => this.handleNumberPattern(newCreditCardDetail['card_cvv'],'cvvNumber')
                                                }
                                                className="mt-3 mt-sm-0"
                                             />
                                             {formErrors.validCardCVV ? <span className="error">Please enter a valid cvv.</span> : null}
                                          </Col>
                                       </FormGroup>
                                       <FormGroup row>
                                          <Col sm={6} lg={6}>
                                             <Label for="expMonth" className="text-uppercase">Exp. Month</Label>
                                             <CustomInput
                                                onChange={(e) => this.handleChange('card_exp_month', e,'validCardExpMonth')} type="select"
                                                name="select"
                                                id="expMonth"
                                                className="form-control"
                                                value={newCreditCardDetail['card_exp_month']}
                                             >
                                                <option disabled value="">Month</option>
                                                {(this.months && (this.months.length > 0)) && this.months.map((month,key)=>{
                                                   if (month){
                                                      return (
                                                         <option key={key} value={month}>{month}</option>
                                                      )
                                                   } else {
                                                      return null;
                                                   }
                                                })}
                                             </CustomInput>
                                             {formErrors.validCardExpMonth ? <span className="error">Please enter a valid month.</span> : null}
                                          </Col>
                                          <Col sm={6} lg={6}>
                                             <Label for="expYear" className="text-uppercase mt-sm-0 mt-3">Exp. Year</Label>
                                             <CustomInput
                                                onChange={(e) => this.handleChange('card_exp_year', e,'validCardExpYear')}
                                                type="select"
                                                name="select"
                                                id="expYear"
                                                className="form-control"
                                                value={newCreditCardDetail['card_exp_year']}
                                             >
                                                <option disabled value="">Year</option>
                                                {(this.years && (this.years.length > 0)) && this.years.map((year, key) => {
                                                   if (year) {
                                                      return (
                                                         <option key={key} value={year}>{year}</option>
                                                      )
                                                   } else {
                                                      return null;
                                                   }
                                                })}
                                             </CustomInput>
                                             {formErrors.validCardExpYear ? <span className="error">Please enter a valid year.</span> : null}
                                          </Col>
                                       </FormGroup>
                                    </div>
                                    {/* Honeypot */}
                                    <div className="d-none">
                                       <FormGroup className="input-group-lg">
                                          <Input type="text" value={shDesignation} onChange={this.handleShDesignationChange} placeholder="Password" id="shDesignation" />
                                       </FormGroup>
                                    </div>
                                    <div className="text-center mb-5 mt-4">
                                       <button
                                          className="btn btn-lg px-5 rounded-btn btn-primary fs-14 text-space"
                                          type="submit"
                                          onClick={this.handleSubmit}
                                       >
                                          Create Account
                                    </button>
                                    </div>
                                 </Form>
                                 {!renderSocialBtn &&
                                    <>
                                       {!isSocialSignup &&
                                          <div className="social-icons-wrap mb-4 text-center">
                                             <SocialButton
                                                className="btn-primary btn-lg fs-14 btn mr-sm-3 mr-md-4 btn-shadow"
                                                provider='facebook'
                                                appId={this.facebookAppId}
                                                onLoginSuccess={this.handleSocialLogin}
                                                {...this.socialLoginProps}
                                             >
                                                <img className="pr-3 d-inline-block" src={process.env.PUBLIC_URL + "/images/facebook-icon.png"} alt="icon" height="26" />
                                                Sign Up With Facebook
                                             </SocialButton>
                                             <SocialButton
                                                className="light-bg btn-lg fs-14 btn btn-shadow"
                                                provider='google'
                                                appId={this.googleClientId}
                                                onLoginSuccess={this.handleSocialLogin}
                                                {...this.socialLoginProps}
                                             >
                                                <img className="pr-3 d-inline-block" alt="icon" src={process.env.PUBLIC_URL + "/images/google-icon.png"} height="26" />
                                                Sign Up With Google
                                             </SocialButton>
                                          </div>
                                       }
                                    </>
                                 }
                                 <div className="text-center">
                                    <span className="fs-14">Already have an account ? <a href="/login" className="text-primary">Login</a></span>
                                 </div>
                                 <div className="tjs-privacy-text">
                                    <small>By entering any information, you affirm you have read and agree to the <a target="_blank" rel="noopener noreferrer" href="https://www.bookingkoala.com/terms-of-use/">Terms of Service</a> and <a rel="noopener noreferrer" target="_blank" href="https://www.bookingkoala.com/privacy-policy/"> Privacy Policy</a>. You also agree and authorize BookingKoala and its affiliates and their networks to deliver marketing and other material via the information provided.</small>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
            }
         </>
      )
   }
}

export default Signup;
